import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormControl } from '@angular/forms';

@Injectable()
export class SeznamSablonFilterFormService {
  public readonly filterForm = new FormGroup({
    interniId: new UntypedFormControl(null),
    nazev: new UntypedFormControl(null),
    verze: new UntypedFormControl(null),
    typ: new UntypedFormControl(null),
    gestor: new UntypedFormControl(null),
    datumPublikovani: new UntypedFormControl(null),
    platnostOd: new UntypedFormControl(null),
    platnostDo: new UntypedFormControl(null),
  });
}
